export const BOTTOM_ESPOT_NAME = 'CAT_MLP_EMARKETINGSPOT_BOTTOM';
export const MIDDLE_ESPOT_NAME = 'CAT_MLP_EMARKETINGSPOT_MIDDLE';
export const TEMP_EQUIPMENT_STATUS = 'temp';
export const SAVE_MY_EQUIPMENT = 'SAVE_MY_EQUIPMENT';
export const EDIT_MY_EQUIPMENT = 'EDIT_MY_EQUIPMENT';
export const ALP_SELECT_DEALER_FLYOUT_SHOWN = 'ALP_SELECT_DEALER_FLYOUT_SHOWN';
export const DESKTOP_MAX_LIMIT_PARTS_BY_CATEGORY = 10;
export const MOBILE_MAX_LIMIT_PARTS_BY_CATEGORY = 8;
export const CAT_CARD_REWARD_LINK = 'cat.com/catcardrewards';
export const SIS2GO_GET_STARTED =
  'https://www.cat.com/en_US/support/maintenance/sis2go-app.html';
export const EQUIPMENT_SAVE_STATUS_SESSION = 'equipmentSaveStatus';
export const CAT_INSPECT_LINK = 'https://www.cat.com/catinspect';
export const REGISTER_FOR_ENGINE_WARRANTY =
  'https://www.cat.com/{0}/support/maintenance/engine-warranty-registration.html?serial_number={1}&sales_model={2}';
export const GENERIC_WARRANTY =
  'https://www.cat.com/{0}/support/maintenance/warranty.html';

export const SUPPORTED_LANGUAGES_FOR_WARRANTY = [
  'de_DE',
  'en_US',
  'fr_FR',
  'it_IT',
  'ja_JP',
  'ko_KR',
  'nl_NL',
  'pl_PL',
  'pt_BR',
  'ru_RU',
  'sv_SE',
  'tr_TR',
  'zh_CN',
  'zh_TW'
];

export const MISMATCH_LOCALES_FOR_WARRANTY = {
  ar_EG: 'ar_SA',
  in_ID: 'id_ID'
};

export const SELECT_DEALER_FLYOUT_IMG = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20231102-0e19b-fccd0?hei=110',
  alt: 'Select Dealer'
};

export const REQUIST_SERVICE_CALENDER = {
  MIN_DATE: 0,
  MAX_DATE: 30
};

export const CVA_LEARN_MORE_LINK_1 =
  'https://www.cat.com/{0}/support/maintenance/customer-value-agreements.html';

export const CVA_LEARN_MORE_LINK_2 =
  'https://www.cat.com/{0}/support/maintenance/customer-value-agreements.html';

export const SUPPORTED_LANGUAGE_1 = ['en_US', 'ar_SA'];

export const SUPPORTED_LANGUAGE_2 = [
  'fr_US',
  'en_MX',
  'en_GB',
  'fr_FR',
  'pl_PL',
  'it_IT',
  'es_ES',
  'de_DE',
  'sv_SE',
  'ru_RU',
  'zh_CN',
  'ja_JP',
  'en_ID',
  'en_ZA',
  'zh_ZA',
  'fr_DZ',
  'tr_TR',
  'pt_BR'
];

export const UNSEEN_STATUS = 'new';
export const SEEN_STATUS = 'seen';
